"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-seventeen/section/footerSection.tsx */

import { SmartImage } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type FooterSectionCirclesItem = {
    key: Key | null | undefined;
    /** Detected variants: "circle" */
    className?: string;
};

type FooterSectionFooterContactsItem = {
    key: Key | null | undefined;
    /** Detected variants: "isax isax-location-tick" | "isax isax-messages-3" | "isax isax-call-calling" */
    className: string;
    /** Detected variants: "Visit Our Clinic" | "General Inquiries" | "Emergency Cases" */
    p0Text: ReactNode;
    /** Detected variants: "1250 Sunset Boulevard, USA" | "info@example.com" | "+1 24565 89856" */
    p1Text: ReactNode;
    /** Detected variants: "footer-contact" */
    divClassName?: string;
    /** Detected variants: "contact-icon" */
    div0ClassName?: string;
    /** Detected variants: "title" */
    p0ClassName?: string;
    /** Detected variants: "mb-0" */
    p1ClassName?: string;
};

type FooterSectionUls3Item = {
    key: Key | null | undefined;
    /** Detected variants: "Privacy Policy" | "Terms & Condition" */
    a0Text: ReactNode;
    /** Detected variants: "#" */
    href?: string;
};

type FooterSectionUlsItem = {
    key: Key | null | undefined;
    /** Detected variants: "facebook" | "twitter" | "instagram" | "linkedin" */
    ariaLabel: string;
    /** Detected variants: "fa-brands fa-facebook" | "fa-brands fa-x-twitter" | "fa-brands fa-instagram" | "fa-brands fa-linkedin" */
    className: string;
    /** Detected variants: "#" */
    href?: string;
};

type FooterSectionUls2Item = {
    key: Key | null | undefined;
    /** Detected variants: "Wellness Therapies & Treatments" | "Mind-Body Healing Programs" | "Preventive Healthcare Services" | "Recovery & Stress Management" | "Personalized Plans" */
    a0Text: ReactNode;
    /** Detected variants: "#" */
    href?: string;
};
export type HomeSeventeenFooterSectionGeneratedProps = {
    footerDiv0Div0ClassName?: string;
    /** Default: "#" */
    footerDiv0Div0Div0Div0A0AHref?: string;
    /** Default: "Schedule Consultation" */
    footerDiv0Div0Div0Div0A0Span1SpanText?: ReactNode;
    /** Default: "Ready to begin your journey home to wellness?" */
    footerDiv0Div0Div0Div0H20H2Text?: ReactNode;
    footerDiv0Div0Div0Div0H20H2Visible?: boolean;
    footerDiv0Div0Div0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    footerDiv0Div0Div0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "Your first consultation is complimentary. No pressure, no commitments — just a genuine conversation about your health and what's possible." */
    footerDiv0Div0Div0Div0P0PText?: ReactNode;
    /** Default: "wellness" */
    footerDiv0Div0Div1Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/footer-02.png" */
    footerDiv0Div0Div1Div0ImageWithBasePath0ImageSrc?: string;
    footerDiv0Div0Div1Div0ImageWithBasePath0ImageVisible?: boolean;
    footerDiv0Div0Div1Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerDiv0Div0Div1Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    footerDiv0Div1Div0ClassName?: string;
    /** Default: "#" */
    footerDiv0Div1Div0Div0Div0A0AHref?: string;
    /** Default: "logo" */
    footerDiv0Div1Div0Div0Div0A0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/logo-17.svg" */
    footerDiv0Div1Div0Div0Div0A0ImageWithBasePath0ImageSrc?: string;
    footerDiv0Div1Div0Div0Div0A0ImageWithBasePath0ImageVisible?: boolean;
    footerDiv0Div1Div0Div0Div0A0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerDiv0Div1Div0Div0Div0A0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "At our Healing & Wellness Center, we prioritize your vision and overall health. Our expert team offers innovative diagnostic treatments and personalized care." */
    footerDiv0Div1Div0Div0Div0P0PText?: ReactNode;
    /** Default: "Our Services" */
    footerDiv0Div1Div0Div1Div0H30H3Text?: ReactNode;
    footerDiv0Div1Div0Div1Div0H30H3Visible?: boolean;
    footerDiv0Div1Div0Div1Div0H30H3Renderer?: (defaultNode: ReactNode) => ReactNode;
    footerDiv0Div1Div0Div1Div0H30H3Props?: Partial<ComponentProps<"h3">>;
    /** Default: "Company" */
    footerDiv0Div1Div0Div2Div0H30H3Text?: ReactNode;
    footerDiv0Div1Div0Div2Div0H30H3Visible?: boolean;
    footerDiv0Div1Div0Div2Div0H30H3Renderer?: (defaultNode: ReactNode) => ReactNode;
    footerDiv0Div1Div0Div2Div0H30H3Props?: Partial<ComponentProps<"h3">>;
    /** Default: "DOCCURE" */
    footerDiv1Div0DivText?: ReactNode;
    /** Default: "Copyright &copy; 2026" */
    footerDiv1Div1P0PText?: ReactNode;
    /** Default: ". All Rights Reserved" */
    footerDiv1Div1P0PText2?: ReactNode;
    /** Default: "#" */
    footerDiv1Div1P0A0AHref?: string;
    /** Default: "Doccure" */
    footerDiv1Div1P0A0AText?: ReactNode;
    footerSectionCircles: FooterSectionCirclesItem[];
    footerSectionFooterContacts: FooterSectionFooterContactsItem[];
    footerSectionUls3: FooterSectionUls3Item[];
    footerSectionUls: FooterSectionUlsItem[];
    footerSectionUls2: FooterSectionUls2Item[];
    footerSectionCirclesItemWrapper?: (item: FooterSectionCirclesItem, content: ReactNode) => ReactNode;
    footerSectionCirclesRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerSectionFooterContactsItemWrapper?: (item: FooterSectionFooterContactsItem, content: ReactNode) => ReactNode;
    footerSectionFooterContactsRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerSectionUls3ItemWrapper?: (item: FooterSectionUls3Item, content: ReactNode) => ReactNode;
    footerSectionUls3Renderer?: (defaultNode: ReactNode) => ReactNode;
    footerSectionUlsItemWrapper?: (item: FooterSectionUlsItem, content: ReactNode) => ReactNode;
    footerSectionUlsRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerSectionUls2ItemWrapper?: (item: FooterSectionUls2Item, content: ReactNode) => ReactNode;
    footerSectionUls2Renderer?: (defaultNode: ReactNode) => ReactNode;
};

const HomeSeventeenFooterSectionGenerated: FC<HomeSeventeenFooterSectionGeneratedProps> = ({
    footerDiv0Div0Div0Div0A0AHref = "#",
    footerDiv0Div0Div0Div0A0Span1SpanText = "Schedule Consultation",
    footerDiv0Div0Div0Div0H20H2Text = "Ready to begin your journey home to wellness?",
    footerDiv0Div0Div0Div0H20H2Visible,
    footerDiv0Div0Div0Div0H20H2Renderer,
    footerDiv0Div0Div0Div0H20H2Props,
    footerDiv0Div0Div0Div0P0PText = "Your first consultation is complimentary. No pressure, no commitments — just a genuine conversation about your health and what's possible.",
    footerDiv0Div0Div1Div0ImageWithBasePath0ImageAlt = "wellness",
    footerDiv0Div0Div1Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/footer-02.png",
    footerDiv0Div0Div1Div0ImageWithBasePath0ImageVisible,
    footerDiv0Div0Div1Div0ImageWithBasePath0ImageRenderer,
    footerDiv0Div0Div1Div0ImageWithBasePath0ImageProps,
    footerDiv0Div1Div0Div0Div0A0AHref = "#",
    footerDiv0Div1Div0Div0Div0A0ImageWithBasePath0ImageAlt = "logo",
    footerDiv0Div1Div0Div0Div0A0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/logo-17.svg",
    footerDiv0Div1Div0Div0Div0A0ImageWithBasePath0ImageVisible,
    footerDiv0Div1Div0Div0Div0A0ImageWithBasePath0ImageRenderer,
    footerDiv0Div1Div0Div0Div0A0ImageWithBasePath0ImageProps,
    footerDiv0Div1Div0Div0Div0P0PText = "At our Healing & Wellness Center, we prioritize your vision and overall health. Our expert team offers innovative diagnostic treatments and personalized care.",
    footerDiv0Div1Div0Div1Div0H30H3Text = "Our Services",
    footerDiv0Div1Div0Div1Div0H30H3Visible,
    footerDiv0Div1Div0Div1Div0H30H3Renderer,
    footerDiv0Div1Div0Div1Div0H30H3Props,
    footerDiv0Div1Div0Div2Div0H30H3Text = "Company",
    footerDiv0Div1Div0Div2Div0H30H3Visible,
    footerDiv0Div1Div0Div2Div0H30H3Renderer,
    footerDiv0Div1Div0Div2Div0H30H3Props,
    footerDiv1Div0DivText = "DOCCURE",
    footerDiv1Div1P0A0AHref = "#",
    footerDiv1Div1P0A0AText = "Doccure",
    footerDiv1Div1P0PText = "Copyright &copy; 2026",
    footerDiv1Div1P0PText2 = ". All Rights Reserved",
    footerDiv0Div0ClassName,
    footerDiv0Div1Div0ClassName,
    footerSectionCircles,
    footerSectionFooterContacts,
    footerSectionUls3,
    footerSectionUls,
    footerSectionUls2,
    footerSectionCirclesItemWrapper,
    footerSectionCirclesRenderer,
    footerSectionFooterContactsItemWrapper,
    footerSectionFooterContactsRenderer,
    footerSectionUls3ItemWrapper,
    footerSectionUls3Renderer,
    footerSectionUlsItemWrapper,
    footerSectionUlsRenderer,
    footerSectionUls2ItemWrapper,
    footerSectionUls2Renderer,
}) => {
    return (
        <footer className="footer footer-seventeen">
            <div className="container">
                <div className={footerDiv0Div0ClassName ?? "row"}>
                    <div className="col-lg-7">
                        <div className="footer-content">
                            {renderNode(footerDiv0Div0Div0Div0H20H2Visible, footerDiv0Div0Div0Div0H20H2Renderer, (
                                <h2 {...(footerDiv0Div0Div0Div0H20H2Props ?? {})}>{footerDiv0Div0Div0Div0H20H2Text}</h2>
                            ))}
                            <p>{footerDiv0Div0Div0Div0P0PText}</p>
                            <a href={footerDiv0Div0Div0Div0A0AHref} className="theme-17-btn">
                                <span className="icon">
                                    <i className="isax isax-calendar5"></i>
                                </span>
                                <span className="text">{footerDiv0Div0Div0Div0A0Span1SpanText}</span>
                                <div className="container-stars">
                                    <div className="stars"></div>
                                </div>
                                <div className="glow">
                                    {renderCollectionNode(
                                        footerSectionCircles,
                                        (item: FooterSectionCirclesItem) => (
                                            <div className={item.className ?? "circle"} key={item.key}></div>
                                        ),
                                        footerSectionCirclesItemWrapper,
                                        footerSectionCirclesRenderer
                                    )}
                                </div>
                            </a>
                        </div>
                    </div>
                    <div className="col-lg-5">
                        <div className="footer-img">
                            {renderNode(footerDiv0Div0Div1Div0ImageWithBasePath0ImageVisible, footerDiv0Div0Div1Div0ImageWithBasePath0ImageRenderer, (
                                <SmartImage src={footerDiv0Div0Div1Div0ImageWithBasePath0ImageSrc} alt={footerDiv0Div0Div1Div0ImageWithBasePath0ImageAlt} className="img-fluid" {...(footerDiv0Div0Div1Div0ImageWithBasePath0ImageProps ?? {})} />
                            ))}
                        </div>
                    </div>
                </div>
                <div className="footer-top">
                    <div className={footerDiv0Div1Div0ClassName ?? "row g-4"}>
                        <div className="col-md-12 col-lg-5 col-xl-6">
                            <div className="footer-widget footer-about">
                                <a href={footerDiv0Div1Div0Div0Div0A0AHref} className="footer-logo">
                                    {renderNode(footerDiv0Div1Div0Div0Div0A0ImageWithBasePath0ImageVisible, footerDiv0Div1Div0Div0Div0A0ImageWithBasePath0ImageRenderer, (
                                        <SmartImage src={footerDiv0Div1Div0Div0Div0A0ImageWithBasePath0ImageSrc} alt={footerDiv0Div1Div0Div0Div0A0ImageWithBasePath0ImageAlt} className="img-fluid" {...(footerDiv0Div1Div0Div0Div0A0ImageWithBasePath0ImageProps ?? {})} />
                                    ))}
                                </a>
                                <p>{footerDiv0Div1Div0Div0Div0P0PText}</p>
                                <ul className="social-icon">
                                    {renderCollectionNode(
                                        footerSectionUls,
                                        (item: FooterSectionUlsItem) => (
                                            <li key={item.key}>
                                                <a href={item.href ?? "#"} aria-label={item.ariaLabel}>
                                                    <i className={item.className}></i>
                                                </a>
                                            </li>
                                        ),
                                        footerSectionUlsItemWrapper,
                                        footerSectionUlsRenderer
                                    )}
                                </ul>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4 col-xl-3">
                            <div className="footer-widget mt-0">
                                {renderNode(footerDiv0Div1Div0Div1Div0H30H3Visible, footerDiv0Div1Div0Div1Div0H30H3Renderer, (
                                    <h3 className="footer-title" {...(footerDiv0Div1Div0Div1Div0H30H3Props ?? {})}>{footerDiv0Div1Div0Div1Div0H30H3Text}</h3>
                                ))}
                                <ul className="footer-menu">
                                    {renderCollectionNode(
                                        footerSectionUls2,
                                        (item: FooterSectionUls2Item) => (
                                            <li key={item.key}>
                                                <a href={item.href ?? "#"}>{item.a0Text}</a>
                                            </li>
                                        ),
                                        footerSectionUls2ItemWrapper,
                                        footerSectionUls2Renderer
                                    )}
                                </ul>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-3 col-xl-3">
                            <div className="footer-widget">
                                {renderNode(footerDiv0Div1Div0Div2Div0H30H3Visible, footerDiv0Div1Div0Div2Div0H30H3Renderer, (
                                    <h3 className="footer-title" {...(footerDiv0Div1Div0Div2Div0H30H3Props ?? {})}>{footerDiv0Div1Div0Div2Div0H30H3Text}</h3>
                                ))}
                                {renderCollectionNode(
                                    footerSectionFooterContacts,
                                    (item: FooterSectionFooterContactsItem) => (
                                        <div className={item.divClassName ?? "footer-contact"} key={item.key}>
                                            <div className={item.div0ClassName ?? "contact-icon"}>
                                                <i className={item.className}></i>
                                            </div>
                                            <div>
                                                <p className={item.p0ClassName ?? "title"}>{item.p0Text}</p>
                                                <p className={item.p1ClassName ?? "mb-0"}>{item.p1Text}</p>
                                            </div>
                                        </div>
                                    ),
                                    footerSectionFooterContactsItemWrapper,
                                    footerSectionFooterContactsRenderer
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="animated-text">{footerDiv1Div0DivText}</div>
                <div className="footer-bottom">
                    <p>
                        {footerDiv1Div1P0PText}
                        <a href={footerDiv1Div1P0A0AHref}>{footerDiv1Div1P0A0AText}</a>
                        {footerDiv1Div1P0PText2}
                    </p>
                    <ul className="policy-links">
                        {renderCollectionNode(
                            footerSectionUls3,
                            (item: FooterSectionUls3Item) => (
                                <li key={item.key}>
                                    <a href={item.href ?? "#"}>{item.a0Text}</a>
                                </li>
                            ),
                            footerSectionUls3ItemWrapper,
                            footerSectionUls3Renderer
                        )}
                    </ul>
                </div>
            </div>
        </footer>
    );
};

export default HomeSeventeenFooterSectionGenerated;
